import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {BrowserModule} from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './home.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';








@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    NgbModule,
    NgxSpinnerModule





  ],
  exports: [
    CommonModule
  ],
  declarations: [
    HomeComponent
    ]
})
export class HomeModule {}






// WEBPACK FOOTER //
// ./src/app/views/home/home.module.ts